<template>
  <div>
    <div
      v-if="loadingDetails"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div v-else>
      <a-table
        :columns="columns"
        :pagination="false"
        :data-source="currentData"
        :custom-header-row="expandAllHandler"
        class="table-list"
      >
        <div
          slot="filterDropdown"
          slot-scope="{ }"
          class="table-custom-filter-dropdown"
        >
          <div class="drop-down-box">
            <a
              href="javascript:;"
              :class="{'filter-active': filtersparams.isinvoice === 3}"
              @click="getList(3)"
            >{{ $t('message["904"]') }}</a>
            <a
              href="javascript:;"
              :class="{'filter-active': filtersparams.isinvoice === 5}"
              @click="getList(5)"
            >{{ $t('message["145"]') }}</a>
            <a
              href="javascript:;"
              :class="{'filter-active': filtersparams.isinvoice === 6}"
              @click="getList(6)"
            >{{ $t('message["1485"]') }}</a>
            <a
              href="javascript:;"
              :class="{'filter-active': filtersparams.isinvoice === 7}"
              @click="getList(7)"
            >{{ $t('message["1459"]') }}</a>
          </div>
        </div>
        <div
          slot="proname"
          slot-scope="proname, record"
          class="order-cell"
        >
          <span>{{ record.proname }}</span>
        </div>
        <div
          slot="addtime"
          slot-scope="addtime, record"
          class="order-cell date-time-cell"
        >
          <span>{{ timestampToTime(record.addtime, '-').date }}</span>
          <p>{{ timestampToTime(record.addtime, '-').time }}</p>
        </div>
        <div
          slot="money"
          slot-scope="money, record"
          class="order-cell"
        >
          <span>{{ record.money }}</span>
        </div>
        <div
          slot="paystatusname"
          slot-scope="paystatusname, record"
          class="order-cell"
        >
          <span v-if="record.paystatus === 1">{{ $t('message["1485"]') }}</span>
          <span
            v-else
            :class="{'wait-for-pay': record.paystatus === 0}"
          >{{ record.paystatusname }}</span>
        </div>
        <div
          slot="paytime"
          slot-scope="paytime, record"
          class="order-cell"
        >
          <span
            v-if="!record.paytime"
          >—</span>
          <template v-else>
            <div class="date-time-cell">
              <span>{{ timestampToTime(record.addtime, '-').date }}</span>
              <p>{{ timestampToTime(record.addtime, '-').time }}</p>
            </div>
          </template>
        </div>
        <div
          slot="paystatus"
          slot-scope="paystatus, record"
          class="order-cell"
        >
          <a
            href="javascript:;"
            @click="viewItemInfo(record.ordersn)"
          >{{ $t('message["1316"]') }}</a>
          <a
            v-if="record.paystatus===0"
            href="javascript:;"
            class="ml-16"
            @click="payMethod(record.ordersn)"
          >{{ $t('message["1594"]') }}</a>
        </div>
      </a-table>
      <order-info-dia
        ref="orderInfoDialog"
        :order-data="itemData"
      />
      <div class="loading">
        <a-button
          v-if="currentData.length >=10"
          :loading="loading"
          :disabled="loading"
          class="load-more-btn"
          @click="getListDatas"
        >
          {{ $t('message["472"]') }}
        </a-button>
      </div>
      <form
        v-if="isSubForm"
        :id="formId"
        method="post"
        :action="posturl"
      >
        <input
          v-for="(val, key) in keyDatas"
          :key="key"
          :name="key"
          type="hidden"
          :value="val"
        >
      </form>
    </div>
  </div>
</template>
<script>
import OrderInfoDia from './OrderInfoDia'
import { cloneDeep } from 'lodash'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { timestampToTime } from '@/store/account/scripts'

export default {
  components: {
    OrderInfoDia
  },
  data () {
    return {
      page: 1,
      isinvoice: 3,
      loading: false,
      isSubForm: true,
      formId: Math.random().toString(10).substring(2),
      datas: {},
      formDatas: {},
      itemData: {},
      filtersparams: {}
    }
  },
  computed: {
    ...mapState('account/order', ['loadingDetails', 'orderListDatas']),
    ...mapGetters('account/order', ['currentData']),
    posturl () {
      return this.formDatas.posturl
    },
    keyDatas () {
      return this.formDatas.data
    },
    columns () {
      const columns = [{
        dataIndex: 'ordersn',
        key: 'ordersn',
        title: this.$t('message["245"]')
      }, {
        title: this.$t('message["1675"]'),
        dataIndex: 'comname',
        key: 'comname'
      }, {
        title: this.$t('message["1318"]'),
        key: 'projectname',
        dataIndex: 'projectname'
      }, {
        title: this.$t('message["660"]'),
        key: 'proname',
        dadaIndex: 'proname',
        scopedSlots: { customRender: 'proname' }
      }, {
        title: this.$t('message["126"]'),
        key: 'addtime',
        dadaIndex: 'addtime',
        scopedSlots: { customRender: 'addtime' },
        width: 120
      }, {
        title: this.$t('message["247"]'),
        key: 'money',
        dadaIndex: 'money',
        scopedSlots: { customRender: 'money' },
        width: 100
      }, {
        title: this.$t('message["1646"]'),
        key: 'paystatusname',
        dadaIndex: 'paystatusname',
        scopedSlots: {
          // filterIcon: 'filterIcon',
          filterDropdown: 'filterDropdown',
          customRender: 'paystatusname'
        },
        filterIcon: <em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test19"></i></em>,
        width: 110
      }, {
        title: this.$t('message["1596"]'),
        key: 'paytime',
        dadaIndex: 'paytime',
        scopedSlots: { customRender: 'paytime' },
        width: 120
      }, {
        title: this.$t('message["79"]'),
        key: 'paystatus',
        dadaIndex: 'paystatus',
        scopedSlots: { customRender: 'paystatus' },
        width: 110
      }]
      return columns
    }
  },
  async mounted () {
    const chain = await this.fetchOrderListDatas()
    chain.params({ isinvoice: 3 })
      .fetch()
  },
  methods: {
    timestampToTime,
    ...mapMutations('account/order', ['setOrderListDatas']),
    ...mapActions('account/order', ['fetchOrderListDatas', 'fetchOrderInfo', 'fetchPay']),
    // 筛选
    async getList (val) {
      this.page = 1
      this.isinvoice = val
      this.filtersparams = { isinvoice: val }
      const chain = await this.fetchOrderListDatas()
      chain.params({ isinvoice: val })
        .fetch()
    },
    async payMethod (order) {
      let res = await this.fetchPay()
      res.params({ ordersn: order })
        .onSuccess(raw => {
          this.isSubForm = true
          this.formDatas = raw
          setTimeout(() => {
            document.getElementById(this.formId).submit()
            this.isSubForm = false
          }, 1000)
        })
        .fetch()
    },
    // 加载更多
    async getListDatas () {
      this.loading = true
      let arr = cloneDeep(this.orderListDatas)
      const chain = await this.fetchOrderListDatas()
      this.page++
      chain.params({ isinvoice: this.isinvoice, page: this.page })
        .onSuccess(res => {
          if (res.length) {
            arr.push(...this.orderListDatas)
            this.setOrderListDatas(arr)
          } else {
            this.page--
            this.setOrderListDatas(arr)
            // alert('已加载完毕！')
            this.$message.warning(this.$t('message["1463"]') + '！')
          }
        })
        .fetch()
      this.loading = false
    },
    async viewItemInfo (id) {
      const chain = await this.fetchOrderInfo()
      chain.params({ ordersn: id })
        .onSuccess(res => {
          this.itemData = res
          this.$refs.orderInfoDialog.changeVisible(true)
        })
        .fetch()
    },
    expandAllHandler (columns, record) {
      columns.forEach(item => {
        if (item.key === 'paystatusname') {
          const obj = !!this.filtersparams['isinvoice']
          item.customHeaderCell = (record) => {
            return {
              attrs: {
                id: obj ? 'filter-th-selected' : '',
                'class': `ant-table-column-has-actions ant-table-column-has-filters ${obj ? 'filter-th-selected' : ''}`
              }
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  // .drop-down-box {
  //   width: 80px;
  //   background: #fff;
  //   border-radius: 4px;
  //   line-height: 30px;
  //   position: relative;
  //   z-index: 6;
  //   box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
  //   a{
  //     display: block;
  //     color:#333;
  //     padding: 0 10px;
  //   }
  //   a:hover {
  //     background: #ebebeb;
  //   }
  // }
  .date-time-cell {
    font-size: 12px;
    p {
      color: #999;
    }
  }
  .wait-for-pay {
    color: #f6a953;
  }
  .table-list::v-deep {
    #filter-th-selected .anticon-filter{
      color: #5077aa !important;
    }
  }
</style>
